import { BaseDiv } from "./BaseDom";
import videojs, { VideoJsPlayer } from "video.js";
import { IOptions } from "../type";
import TimelineRiver from "./TimelineRiver";

export default class CustomizableControlBar extends BaseDiv {
  constructor(player: VideoJsPlayer, opts?: IOptions) {
    super(player);
    this.addClass("vjs-control-bar-river");
    const width = opts?.width === undefined ? "100%" : `${opts?.width}px`;
    const height = opts?.height === undefined ? "50px" : `${opts?.height}px`;
    this.setStyle({
      position: "absolute",
      bottom: 0,
      width: width,
      height: height,
      // background: "rgba(0, 0, 0, 0.3)",
      "background-image":
        "linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4))",
    });
    // unclickable control items
    videojs.registerComponent("TimelineRiver", TimelineRiver);
    this.addChild("TimelineRiver", opts);
    // clickable control items
    const progressControl = this.addChild("ProgressControl");
    progressControl.setAttribute(
      "style",
      `
      margin-top: 10px;
      width: 100%;
      height: 2em;
    `
    );
    videojs.registerComponent("ControlItems", ControlItems);
    this.addChild("ControlItems");
  }
}

class ControlItems extends BaseDiv {
  constructor(player: VideoJsPlayer) {
    super(player);
    this.addClass("vjs-control-items");
    this.setStyle({
      display: "flex",
      width: "100%",
      height: "3em",
    });
    // 4em for each control item
    this.addChild("PlayToggle");
    this.addChild("RemainingTimeDisplay");
    this.addChild("VolumePanel");
    const spacer = this.addChild("Spacer");
    spacer.setAttribute(
      "style",
      `
      width: 60vw;
    `
    );
    this.addChild("PictureInPictureToggle");
    this.addChild("FullscreenToggle");
  }
}
